interface ConditionNodeSummaryProps {
  label: string;
  detail: string;
}

export function ConditionNodeSummary({
  label,
  detail,
}: ConditionNodeSummaryProps) {
  return (
    <div
      className="flex min-w-0 flex-1 items-center gap-1.5"
      onPointerDown={(event) => event.stopPropagation()}
    >
      <span className="min-w-0 truncate text-sm text-muted-foreground">
        <span className="font-medium text-foreground">{label}</span>
        <span aria-hidden="true"> · </span>
        {detail}
      </span>
    </div>
  );
}
